
import { Component, Vue, Prop } from 'vue-property-decorator'
import {
  UserClient,
  RoleClient,
  GroupClient,
  PermissionClient,
  CompanyClient,
  StationClient
} from '@/api'
import {
  IPermissionData,
  IGroupData,
  IRoleData,
  IStationData,
  ICompanyData
} from '@/api/types'
import _ from 'lodash'
import BaseEditor from '@/views/BaseEditor'
@Component({
  name: 'UserEditor'
})
export default class extends BaseEditor {
  private permissionList: IPermissionData[];
  private groupList: IGroupData[];
  private roleList: IRoleData[];
  private companyList: ICompanyData[];
  private stationList: IStationData[];
  private roleClient = new RoleClient();
  private groupClient = new GroupClient();
  private permissionClient = new PermissionClient();
  private companyClient = new CompanyClient();
  private stationClient = new StationClient();

  public constructor() {
    super()
    this.client = new UserClient()
    this.data = {
      name: '',
      username: '',
      avatar: '',
      email: '',
      companyId: '',
      stationId: '',
      permission_list: [],
      group_list: [],
      roleId: ''
    }
    this.rules = {}
    this.permissionList = []
    this.groupList = []
    this.roleList = []
    this.companyList = []
    this.stationList = []
  }

  public async getData(id = -1) {
    await super.getData(id)
    await this.getPermissionList()
    await this.getRoleList()
    await this.getGroupList()
    await this.getCompanyList()
    await this.getStationList()
  }

  protected formatData(data: any): any {
    if (data.permission_list === null) {
      data.permission_list = []
    } else {
      data.permission_list = JSON.parse(data.permission_list)
    }

    if (data.group_list === null) {
      data.group_list = []
    } else {
      data.group_list = JSON.parse(data.group_list)
    }

    return data
  }

  private async getPermissionList() {
    this.permissionList = await this.permissionClient.fetch({
      filter: {
        where: { isDeleted: false },
        fields: {
          id: true,
          name: true,
          description: true
        },
        order: ['createdAt']
      }
    })
  }

  private async getGroupList() {
    this.groupList = await this.groupClient.fetch({
      filter: {
        where: { isDeleted: false },
        fields: {
          id: true,
          name: true,
          description: true
        },
        order: ['createdAt']
      }
    })
  }

  private async getRoleList() {
    this.roleList = await this.roleClient.fetch({
      filter: {
        where: { isDeleted: false },
        fields: {
          id: true,
          name: true,
          description: true
        },
        order: ['createdAt']
      }
    })
  }

  private async getCompanyList() {
    this.companyList = await this.companyClient.fetch({
      filter: {
        where: { isDeleted: false },
        fields: {
          id: true,
          name: true,
          nickName: true
        },
        order: ['name']
      }
    })
  }

  private async getStationList() {
    this.stationList = await this.stationClient.fetch({
      filter: {
        where: { isDeleted: false },
        fields: {
          id: true,
          name: true,
          nickName: true
        },
        order: ['name']
      }
    })
  }

  public async reset() {
    this.data = {
      name: '',
      username: '',
      avatar: '',
      email: '',
      companyId: '',
      stationId: '',
      permission_list: [],
      group_list: [],
      roleId: ''
    }
  }

  protected generateData(): any {
    return {
      permission_list: JSON.stringify(this.data.permission_list),
      group_list: JSON.stringify(this.data.group_list),
      roleId: this.data.roleId,
      name: this.data.name,
      username: this.data.username,
      avatar: this.data.avatar,
      email: this.data.email,
      companyId: Number(this.data.roleId) !== 2
        ? undefined
        : Number(this.data.companyId),
      stationId: Number(this.data.roleId) !== 3
        ? undefined
        : Number(this.data.stationId)
    }
  }
}
